// src/app/config/app-config.ts
export const VAGA_CONFIG = {
  DROPDOWN_SETTINGS: {
    singleSelection: true,
    idField: 'item_id',
    textField: 'item_text',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true,
    searchPlaceholderText: 'Pesquisar',
    noDataLabel: "Sem dados disponíveis",
    enableSearchFilter: true,
    disabled: false,
    badgeShowLimit: 3,
    noFilteredDataAvailablePlaceholderText: 'Nenhum dado filtrado disponível'
  },

  EDITOR_CONFIG: {
    toolbar: ['heading',
      '|',
      'fontSize',
      'fontFamily',
      '|',
      'fontColor',
      'fontBackgroundColor',
      '|',
      'bold',
      'italic',
      'underline',
      'strikethrough',
      '|',
      'alignment',
      '|',
      'numberedList',
      'bulletedList',
      'todoList',
      '|',
      'outdent',
      'indent',
      '|',
      'link',
      'blockQuote',
      'insertTable',
      '|',
      'undo',
      'redo'
    ],

    heading: {
      options: [
        { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
        { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
        { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' }
      ]
    },
    language: 'pt-br',
  },

  MY_FORMATS: {
    parse: {
      dateInput: 'DD/MM/YYYY',
    },
    display: {
      dateInput: 'DD/MM/YYYY',
      monthYearLabel: 'MM YYYY',
      dateA11yLabel: 'DD/MM/YYYY',
      monthYearA11yLabel: 'MM YYYY',
    },
  },

  CHAT_WIDGET_CONFIG: {
    scriptUrl: 'https://storage.googleapis.com/chipp-chat-widget-assets/build/bundle.js',
    styleUrl: 'assets/chat/chat.css',
    appUrl: 'https://bussolaconecta.iavalley.co',
    appId: 13972,
    defaultSize: { width: '400px', height: '600px' },
    mobileSize: { width: '100vw', height: '80vh' },
    mobilePosition: 'bottom',
    desktopPosition: 'bottom-right',
  }
};
